import { getRootAppWindow } from "./getRootAppWindow";
export function getRootApi(windowToUse = window) {
    return getRootAppWindow(windowToUse).RootAPI;
}
